import React, { FC } from 'react'
import { Button, Modal } from 'UI'
import { ModalHeight, ModalSize } from 'UI/Modal/types'
import { ButtonStyles } from 'UI/Button/types'
import { useDisableScrollManual } from 'hooks/useDisableScrollManual'
import { useNavigate } from 'react-router-dom'
import cl from './style.module.scss'

interface PublishModalProps {
	isOpen: boolean
	courseTitle: string
	onClose: () => void
}

const PublishModal: FC<PublishModalProps> = ({
	isOpen,
	courseTitle,
	onClose
}) => {
	const navigate = useNavigate()
	useDisableScrollManual(isOpen)
	return (
		<Modal
			onClose={onClose}
			isOpen={isOpen}
			styleTypes={[ModalSize.BIG, ModalHeight.SMALL]}
			title="Курс успешно опубликован"
			description={`Вы можете найти курс "${courseTitle}" в разделе "Опубликованные" `}
		>
			<div className={cl.buttonsContainer}>
				<Button
					onClick={() => {
						navigate('/')
						onClose()
					}}
					styleTypes={[ButtonStyles.DARK, ButtonStyles.ROUND]}
				>
					Перейти к списку курсов
				</Button>
			</div>
		</Modal>
	)
}

export default PublishModal
